import { CommonModule } from '@angular/common';
import { Component, ElementRef, Renderer2 } from '@angular/core';
import { I18nModule, ProductSearchService } from '@spartacus/core';
import { FacetModule, FacetService, IconModule, KeyboardFocusModule } from '@spartacus/storefront';
import {  FacetListComponent } from '@spartacus/storefront';
import {  map } from 'rxjs';

@Component({
  selector: 'cx-facet-list',
  standalone: true,
  imports: [CommonModule, FacetModule, I18nModule, IconModule, KeyboardFocusModule, CustomProductFacetListComponent],
  templateUrl: './custom-product-facet-list.component.html',
  styleUrl: './custom-product-facet-list.component.scss'
})
export class CustomProductFacetListComponent  extends FacetListComponent{
  results$ = this.productSearchService.getResults();

  override facetList$ = this.results$.pipe(
    map((results: any) => results.facets), // NOSONAR
    map(facets => facets?.map(facet => ({...facet, name: "Comprar por " + facet?.name})))
  );

  constructor(
    protected override facetService: FacetService,
    protected override elementRef: ElementRef,
    protected override renderer: Renderer2,
    private productSearchService: ProductSearchService
  ) {
    super(facetService, elementRef, renderer);
  }
}
